import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpClient, HttpParams } from '@angular/common/http';
import {
  CourseFilter,
  ListCourseResponse,
  CourseData,
} from 'src/app/class/datatype';
import { environment } from 'src/environments/environment';

@Injectable()
export class CourseService {
  constructor(private http: HttpClient) { }

  listCourse(filter: CourseFilter): Observable<ListCourseResponse> {
    let params = new HttpParams();

    if (filter.code) {
      params = params.append('code', filter.code.toString());
    }

    if (filter.name) {
      params = params.append('name', filter.name.toString());
    }

    if (filter.branch) {
      params = params.append('branch', filter.branch.toString());
    }

    if (filter.periode) {
      filter.periode.forEach((d) => {
        params = params.append('periode[]', d);
      })
    }

    if (filter.education) {
      filter.education.forEach((d) => {
        params = params.append('jenjang[]', d);
      });
    }

    if (filter.active_date) {
      params = params.append('active_date', filter.active_date.toString());
    }

    if (filter.active_month) {
      params = params.append('active_month', filter.active_month.toString());
    }

    if (filter.active_year) {
      params = params.append('active_year', filter.active_year.toString());
    }

    if (filter.hasActiveStudent) {
      params = params.append('hasActiveStudent', 1);
    }

    if (filter.studentPeriode) {
      params = params.append('studentPeriode', filter.studentPeriode);
    }

    if (filter.status) {
      params = params.append('status', filter.status.toString());
    }

    params = params.append('page', filter.page.toString());
    params = params.append('per_page', filter.per_page.toString());

    return this.http.get<ListCourseResponse>(
      environment.apiUrl + 'clientapi/admin/course',
      { params }
    );
  }

  getCourse(code: string): Observable<CourseData> {
    return this.http.get<CourseData>(
      environment.apiUrl + 'clientapi/admin/course/' + code
    );
  }

  getRegistrationLink(course: CourseData): Observable<any> {

    return this.http.post<any>(environment.apiUrl + 'clientapi/admin/course/get-registration-link', course);
  }

  getAllCourse(branch?: any, status?: any): Observable<any> {

    let params = new HttpParams();

    if (branch) {
      params = params.append('branch', branch);
    }

    if (status) {
      params = params.append('status', status);
    }

    return this.http.get<any>(
      environment.apiUrl + 'clientapi/admin/course/all-courses',
      { params }
    )
  }

  saveCourse(data: CourseData): Observable<any> {
    if (data.id) {
      return this.http.put(environment.apiUrl + 'clientapi/admin/course', data);
    } else {
      return this.http.post(
        environment.apiUrl + 'clientapi/admin/course',
        data
      );
    }
  }

  uploadFile(data): Observable<any> {

    const file: File = data.target.files[0];

    const formData = new FormData();

    formData.append('file', file);

    return this.http.post(
      environment.apiUrl + 'clientapi/admin/course/upload-file-attachment',
      formData
    );
  }
}
